var React = require('react');

function PlusMinus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 10.998h-6v6h-2v-6H5v-2h6v-6h2v6h6v2zm0 10H5v-2h14v2z"}));
}

PlusMinus.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = PlusMinus;

PlusMinus.default = PlusMinus;
